import { booleanAttribute, Component, input } from '@angular/core';
import { BaseConfig } from '../common/config/config.adapter';

@Component({
  selector: 'lepi-menu',
  standalone: true,
  templateUrl: './menu.component.html',
  imports: [],
})
export class Menu extends BaseConfig {
  overflow = input<boolean, string>(false, { transform: booleanAttribute });
}
